module.exports = __webpack_public_path__ + "static/media/JCB.e87b1ac2.png";